import { render, staticRenderFns } from "./ARSearch.vue?vue&type=template&id=7020d964&scoped=true&"
import script from "./ARSearch.vue?vue&type=script&lang=js&"
export * from "./ARSearch.vue?vue&type=script&lang=js&"
import style0 from "./ARSearch.vue?vue&type=style&index=0&id=7020d964&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7020d964",
  null
  
)

export default component.exports